import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectorListComponent } from './sector-list/sector-list.component';
import { SectorFormComponent } from './sector-form/sector-form.component';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SectorViewComponent } from './sector-view/sector-view.component';
import { MaterialModule } from '../material/material.module';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [SectorListComponent, SectorFormComponent, SectorViewComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatRadioModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatPaginatorModule,
    MaterialModule,
    ComponentsModule,
  ],
})
export class SectorModule {}
